import { Body, Controller, Post } from '@nestjs/common';
import { ApplicationExceptionHandler } from '@schemax-whatsapp/backend-utils';
import { AssociatesResponse, GymDepartmentResponse, GymEmployeesResponse } from '@schemax-whatsapp/shared-models';
import { GymDbConnection } from '../db-connections/gym-db-connection';
import { CompanyDeptRoleCategoryCodeRequest } from '../whatsapp-broad-cast/model/company-dept-role-cat.request';
import { GymInfoService } from './gym-info.service';
import { CompanyIdRequest } from './models/company-id.request';

@Controller('gym-info')
export class GymInfoController {
  constructor(
    private applicationExceptionHandler: ApplicationExceptionHandler,
    private gymService: GymInfoService,
  ) { }

  @Post('getGymResources')
  async getGymResources(@Body() req: CompanyDeptRoleCategoryCodeRequest): Promise<GymEmployeesResponse> {
    try {
      return await this.gymService.getGymResources(req);
    } catch (err) {
      console.log(err);
      return this.applicationExceptionHandler.returnException(GymEmployeesResponse, err);
    }
  }

  @Post('getGymVendors')
  async getGymVendors(@Body() req: CompanyIdRequest): Promise<GymEmployeesResponse> {
    try {
      return await this.gymService.getGymVendors(req);
    } catch (err) {
      console.log(err);
      return this.applicationExceptionHandler.returnException(GymEmployeesResponse, err);
    }
  }

  @Post('getGymCustomers')
  async getGymCustomers(@Body() req: CompanyIdRequest): Promise<GymEmployeesResponse> {
    try {
      return await this.gymService.getGymCustomers(req);
    } catch (err) {
      console.log(err);
      return this.applicationExceptionHandler.returnException(GymEmployeesResponse, err);
    }
  }

  @Post('getGymDepartments')
  async getGymDepartments(@Body() req: CompanyIdRequest): Promise<GymDepartmentResponse> {
    try {
      return await this.gymService.getGymDepartments(req);
    } catch (err) {
      return this.applicationExceptionHandler.returnException(GymDepartmentResponse, err);
    }
  }

}
